export default __webpack_public_path__ + "static/media/010-cat.37795943.svg";